import clsx from 'clsx';
import { forwardRef } from 'react';
export function Section(props) {
    return <div {...props} className={clsx('openapi-section', props.className)}/>;
}
export function SectionHeader(props) {
    return (<div {...props} className={clsx('openapi-section-header', props.className && "".concat(props.className, "-header"))}/>);
}
export function SectionHeaderContent(props) {
    return (<div {...props} className={clsx('openapi-section-header-content', props.className && "".concat(props.className, "-header-content"))}/>);
}
export var SectionBody = forwardRef(function SectionBody(props, ref) {
    return (<div ref={ref} {...props} className={clsx('openapi-section-body', props.className && "".concat(props.className, "-body"))}/>);
});
export function SectionFooter(props) {
    return (<div {...props} className={clsx('openapi-section-footer', props.className && "".concat(props.className, "-footer"))}/>);
}
export function SectionFooterContent(props) {
    return (<div {...props} className={clsx('openapi-section-footer-content', props.className && "".concat(props.className, "-footer-content"))}/>);
}
export function StaticSection(props) {
    var className = props.className, header = props.header, children = props.children, footer = props.footer;
    return (<Section className={className}>
            {header ? (<SectionHeader className={className}>
                    <SectionHeaderContent className={className}>{header}</SectionHeaderContent>
                </SectionHeader>) : null}
            <SectionBody className={className}>{children}</SectionBody>
            {footer ? (<SectionFooter className={className}>
                    <SectionFooterContent className={className}>{footer}</SectionFooterContent>
                </SectionFooter>) : null}
        </Section>);
}
